import html2canvas from "html2canvas";
import { OffsetTypes, defaultOff, defaultOffsets } from "./interface/ui";

export function textToClipboard(text: string) {
    const dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}

export const renderUntoScreen = ({
    rendered,
    ref,
    innerRef,
    scaleTo,
    holderName,
    timeout = 200,
    offset = defaultOffsets,
}: {
    rendered: boolean;
    ref: React.RefObject<HTMLDivElement | null>;
    innerRef: React.RefObject<HTMLDivElement | null>;
    scaleTo: number;
    holderName: string;
    timeout?: number;
    offset?: OffsetTypes;
}) => {
    const useOff: OffsetTypes = {
        yearHolder: {
            ...defaultOff,
            ...offset.yearHolder,
        },
        sigHolder: {
            ...defaultOff,
            ...offset.sigHolder,
        },
        colHolder: {
            ...defaultOff,
            ...offset.colHolder,
        },
        tinHolder: {
            ...defaultOff,
            ...offset.tinHolder,
        },
        ivesHolder: {
            ...defaultOff,
            ...offset.ivesHolder,
        },
    };

    if (rendered) {
        setTimeout(() => {
            if (ref?.current) {
                html2canvas(ref.current, {
                    x:
                        holderName === "ivesHolder"
                            ? 20 + useOff.yearHolder.x
                            : holderName === "formnumHolder"
                              ? 10 + useOff.yearHolder.x
                              : holderName === "yearHolder"
                                ? ref.current.clientWidth / 2 + 10 + useOff.yearHolder.x
                                : holderName === "sigHolder"
                                  ? 20 + useOff.sigHolder.x
                                  : holderName === "colHolder"
                                    ? ref.current.clientWidth / 2 - 95 + useOff.colHolder.x
                                    : ref.current.clientWidth - 285 + useOff.tinHolder.x,
                    y:
                        holderName === "ivesHolder"
                            ? ref.current.clientHeight * 0.3 + useOff.yearHolder.y
                            : holderName === "formnumHolder"
                              ? 25 + useOff.yearHolder.y
                              : holderName === "yearHolder"
                                ? ref.current.clientHeight / 2 - 25 + useOff.yearHolder.y
                                : holderName === "sigHolder"
                                  ? ref.current.clientHeight - 170 + useOff.sigHolder.y
                                  : holderName === "colHolder"
                                    ? ref.current.clientHeight / 2 - 25 + useOff.colHolder.y
                                    : 110 + useOff.tinHolder.y,
                    width:
                        holderName === "ivesHolder"
                            ? 200 + useOff.yearHolder.height
                            : holderName === "formnumHolder"
                              ? 150 + useOff.yearHolder.height
                              : holderName === "yearHolder"
                                ? 135 + useOff.yearHolder.height
                                : holderName === "sigHolder"
                                  ? 360 + useOff.sigHolder.height
                                  : holderName === "colHolder"
                                    ? 80 + useOff.colHolder.height
                                    : 130 + useOff.tinHolder.height,
                    height:
                        holderName === "ivesHolder"
                            ? 60 + useOff.yearHolder.width
                            : holderName === "formnumHolder"
                              ? 60 + useOff.yearHolder.width
                              : holderName === "yearHolder"
                                ? 100 + useOff.yearHolder.width
                                : holderName === "sigHolder"
                                  ? 122 + useOff.sigHolder.width
                                  : holderName === "colHolder"
                                    ? 100 + useOff.colHolder.width
                                    : 60 + useOff.tinHolder.width,
                    logging: false,
                }).then((canvas) => {
                    if (innerRef.current) {
                        const newCan = canvas;
                        try {
                            const holder = document.getElementById(holderName);

                            if (holder) innerRef.current.removeChild(holder);
                        } catch {
                            console.error("Removal failed");
                        }
                        const { width, height } = newCan;
                        newCan.style.width = `${width * scaleTo}px`;
                        newCan.style.height = `${height * scaleTo}px`;
                        newCan.id = holderName;

                        innerRef.current.appendChild(newCan);
                    }
                });
            }
        }, timeout);
    }
};

export const hotKeysConfig: { button: string; action: string }[] = [
    {
        button: "n",
        action: "Next Request",
    },
    {
        button: "p",
        action: "Stop Waiting",
    },
    {
        button: "t",
        action: "Mark TIN Correct",
    },
    {
        button: "f",
        action: "Mark Column (b) Correct",
    },
    {
        button: "s",
        action: "Mark 8821 Signature Correct",
    },
    {
        button: "c",
        action: "Submit to IRS/Submit Action Needed",
    },
    {
        button: "e",
        action: "Next Error",
    },
    {
        button: "shift+e",
        action: "Previous Error",
    },
    {
        button: "Left Arrow",
        action: "Page Left",
    },
    {
        button: "Right Arrow",
        action: "Page Right",
    },
];

export const randomColor = () => ({
    r: Math.floor(Math.random() * 200) + 24,
    g: Math.floor(Math.random() * 200) + 24,
    b: Math.floor(Math.random() * 200) + 24,
});

export const getTaxPeriodYear = (period: string): string => {
    const nowYear = new Date().getFullYear();
    const nowMonth = new Date().getMonth();
    const tp = period.toLowerCase();
    if (!tp.startsWith("year")) return tp;

    const [_, numStr] = tp.split(" ");
    const num = Number(numStr);
    return String(nowYear - num - (nowMonth > 4 ? 0 : 1));
};

export const priorityList: string[] = [
    "bob.maguire@halcyonsw.com",
    "bob.maguire@halcyonsolutions.ai",
    "jim.mcgowan@halcyonsw.com",
    "jim.mcgowan@halcyonsolutions.ai",
    "ahad.khan@halcyonsw.com",
    "ahad.khan@halcyonsolutions.ai",
    "eboonin@halcyonsw.com",
    "eboonin@halcyonsolutions.ai",
    "anthony.lubrino@halcyonsw.com",
    "anthony.lubrino@halcyonsolutions.ai",
];

export const uiManagementList: string[] = [
    ...priorityList,
    "erin.walker@halcyonsw.com",
    "erin.walker@halcyonsolutions.ai",
    "kirk@halcyonsw.com",
    "kirk@halcyonsolutions.ai",
    "bridget.trevino@halcyonsw.com",
    "bridget.trevino@halcyonsolutions.ai",
];

export const developerList: string[] = [
    "bob.maguire@halcyonsw.com",
    "bob.maguire@halcyonsolutions.ai",
    "jim.mcgowan@halcyonsw.com",
    "jim.mcgowan@halcyonsolutions.ai",
    "james.lee@halcyonsw.com",
    "james.lee@halcyonsolutions.ai",
    "vijay.parikh@halcyonsw.com",
    "vijay.parikh@halcyonsolutions.ai",
    "jagadeeswara.yarra@halcyonsw.com",
    "jagadeeswara.yarra@halcyonsolutions.ai",
    "anthony.lubrino@halcyonsw.com",
    "anthony.lubrino@halcyonsolutions.ai",
];

export const promptManagementList: string[] = [
    "bob.maguire@halcyonsw.com",
    "bob.maguire@halcyonsolutions.ai",
    "jim.mcgowan@halcyonsw.com",
    "jim.mcgowan@halcyonsolutions.ai",
    "james.lee@halcyonsw.com",
    "james.lee@halcyonsolutions.ai",
    "anthony.lubrino@halcyonsw.com",
    "anthony.lubrino@halcyonsolutions.ai",
];

export const configManagementList: string[] = [
    ...promptManagementList,
    "kusum.singh@halcyonsw.com",
    "kusum.singh@halcyonsolutions.ai",
    "prashant.bhadresha@halcyonsw.com",
    "prashant.bhadresha@halcyonsolutions.ai",
    "sunit.sharma@halcyonsw.com",
    "sunit.sharma@halcyonsolutions.ai",
];

export function get(obj: any, path: string, defaultValue?: any): any {
    // Convert string path to an array of keys (handling both dot and bracket notation)
    const keys = Array.isArray(path)
        ? path
        : path
              .replace(/\[(\w+)\]/g, ".$1")
              .split(".")
              .filter(Boolean);

    let current = obj;
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (current === null || current === undefined || typeof current !== "object" || !(key in current)) {
            return defaultValue;
        }
        current = current[key];
    }
    return current === undefined ? defaultValue : current;
}

export function normalizeTins(tin?: string): string {
    return tin ? tin.replace(/[^0-9]/g, "").padStart(9, "0") : "";
}

const NAME_STOPWORDS = new Set([
    "and", "or", "the",
    "jr", "sr", "ii", "iii", "iv",
    "mr", "mrs", "ms", "dr",
]);

export function normalizeNameTokens(name?: string): string[] {
    if (!name) return [];
    return name
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, " ")
        .split(/\s+/)
        .filter((t) => t.length > 1 && !NAME_STOPWORDS.has(t));
}

export function set(obj: any, path: string, value: any): any {
    const keys = Array.isArray(path)
        ? path
        : path
              .replace(/\[(\w+)\]/g, ".$1")
              .split(".")
              .filter(Boolean);

    const result = { ...obj };
    let current = result;

    for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        current[key] = current[key] !== undefined && current[key] !== null ? { ...current[key] } : {};
        current = current[key];
    }

    current[keys[keys.length - 1]] = value;
    return result;
}
